export default class SearchTopic {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu Searched', params);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/topics_menu/search_topic.js